<template>
   <Card container-class="card shadow-sm" :title="$t('events.badge.title')">
      <template #cardBody>
        <div class="row">
          <div class="col-md-5">
            <Select2
                :multiple="true"
                :show-search="true"
                name="selectParticipatorStatus"
                :placeholder-text="$t('expenses.label.allStatus')"
                :isRequired="true"
                @update:modelValue="reset"
                v-model="query.status_ids">
              <option value="" selected> {{ $t('expenses.label.allStatus') }} </option>
              <option v-for="(stat, index) in eventStatus" :key="index" :value="stat.id">
                {{ stat.name }}
              </option>
            </Select2>
          </div>
          <div class="col-md-5">
            <Select2
                :multiple="true"
                :show-search="true"
                name="selectParticipator"
                :placeholder-text="$t('events.badge.allParticipator')"
                :isRequired="true"
                @update:modelValue="reset"
                v-model="query.participator_ids">
              <option value="" selected> {{ $t('events.badge.allParticipator') }}  </option>
              <option v-for="(participator, index) in participators" :key="index" :value="participator.id">
                {{ participator.lastname + ' ' + participator.firstname }}
              </option>
            </Select2>
          </div>
          <div class="col-md-2 d-flex align-items-center">
            <Button v-if="!participatorBadges.length" btn-class="btn-sm me-3" type="new" btn-text="button.generate"  @click="generateBadgeFile" :is-loading="processing"/>
            <Button v-if="participatorBadges.length" btn-class="btn-sm me-3" type="new" btn-text="events.badge.print" @click.prevent="printFile" />
            <Button v-if="participatorBadges.length" btn-class="btn-sm btn-danger me-3" type="button" btn-text="button.cancel" @click="reset" />
          </div>
        </div>
        <div v-show="participatorBadges.length" id="print" class="my-5">
          <iframe ref="badgeFrame" frameborder="0" style="width: 100%; min-height: 1000px;"></iframe>
        </div>
        <div v-show="!participatorBadges.length" class="row my-5">
              <Badge :template="badgeTemplates" :can-edit="true"/>
        </div>
      </template>
   </Card>    

</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";

import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import Select2 from "@/components/Select2.vue";
import Badge from "./Badge.vue";
import { computed } from "vue";
import {useLocales} from "@/composables/locales";

const route = useRoute()

const store = useStore()
const {locale} = useLocales()

const processing = ref(false)
const badgeFrame = ref()
const participators = ref([])
const participatorBadges = ref([])
const query = ref({
  status_ids: [],
  participator_ids: []
})


const eventStatus = computed(() => store.getters['events/getEventStatus'])
const badgeTemplates = computed(() => store.getters['eventBadge/eventBadgeTemplate'])

watch(() => route.query.tab, (value) => {
  if(value && value === 'tab-badges') {
    loadParticipators()
    store.dispatch('eventBadge/getEventBadgeTemplate', route.params.id)
  }
})

watch(() => participatorBadges.value , (newVal) => {
  if (newVal.length) {
    const iframe = badgeFrame.value
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    const fullHTML = `
      <html>
        <head>
          <style>
             body {
                margin: 0;
              }
              .gjs-grid-row {
                flex-direction: row ;
              }


              .gjs-grid-column {
                page-break-inside: avoid;
              }

          </style>
        </head>
        <body>
          ${newVal.map(badge => `<div class="badge">${badge}</div>`).join("")}
        </body>
      </html>
    `;

    doc.open();
    doc.write(fullHTML);
    doc.close();
  }
}, { immediate: true });



function loadParticipators(){
    if(route.query.tab === 'tab-badges') {
        store.dispatch("events/loadEventParticipators", route.params.id).then(resp => {
            participators.value = resp.data
        })
    }
}

function printFile () {
  if(badgeFrame.value) {
    badgeFrame.value.contentWindow.print()
  }
}

function generateBadgeFile() {
  processing.value = true
  store.dispatch("eventBadge/generateBadgeFile", {id: route.params.id, ...query.value})
      .then(res => {
        participatorBadges.value = res.data.data
      })
      .finally(() => processing.value = false)
}

function reset() {
  participatorBadges.value = []
}

onMounted(() => {
  if(route.query.tab === 'tab-badges') {
    loadParticipators()
    store.dispatch('eventBadge/getEventBadgeTemplate', route.params.id)
  }
  store.dispatch('events/loadEventStatus')
})
</script>

<style >
@media print {
  body {
    margin: 0;
  }
  .gjs-grid-row {
    flex-direction: row !important;
  }


  .gjs-grid-column {
    page-break-inside: avoid;
  }
  
}
</style>
